import type { UserReactionEmoji } from "@/types/reactions.ts";

/**
 * What each quick reaction in the picker is called: the screen reader's label
 * on web, and the menu item's text beside the emoji on iOS. Client-only — the
 * server takes any single emoji and never names them.
 */
export const userReactionLabels: Record<UserReactionEmoji, string> = {
  "👍": "Thumbs up",
  "👎": "Thumbs down",
  "❤️": "Heart",
  "❌": "No",
};
